<template>
  <span>{{formatValue(Number(animatedValue))}}</span>
</template>

<script>
import anime from "animejs";

export default {
	name: "AnimatedNumber",
	props: {
		value: {
			type: [Number, String],
			default: "0",
			required: true,
		},
		formatValue: {
			type: Function,
			default: value => value,
		},
		easing: {
			type: String,
			default: "linear",
		},
		duration: {
			type: Number,
			default: 200,
		},
		update: Function,
		begin: Function,
		complete: Function,
		run: Function,
		delay: {
			type: Number,
			default: 0,
		},
		appear: {
			type: Boolean,
			default: false,
		},
	},
	data: function() {
		return {
			animatedValue: this.appear ? 0 : this.value,
		};
	},
	mounted() {
		if (this.appear) {
			this.animateValue(this.value);
		}
	},
	watch: {
		value(value) {
			this.animateValue(value);
		},
	},
	methods: {
		animateValue(value) {
			const {
				begin,
				easing,
				duration,
				complete,
				update,
				run,
				delay,
			} = this;
			anime({
				targets: this,
				animatedValue: value,
				duration,
				easing,
				update,
				begin,
				complete,
				run,
				delay,
			});
		},
	},
};
</script>

<style scoped>
	span {
		font-variant-numeric: tabular-nums;
	}
</style>